class Relationship {
    id: number;
    joinType: JoinTypeEnum;
    parentTableId: number;
    childTableId: number;
    fields: Array<RelationshipField>;
    parentFieldsName: string;
    childFieldsName: string;

    constructor(data: any = null) {
        this.id = data?.id ?? 0;
        this.joinType = data?.joinType ?? JoinTypeEnum.Left;
        this.parentTableId = data?.parentTableId ?? null;
        this.childTableId = data?.childTableId ?? null;
        this.fields = createInstances(RelationshipField, data?.fields ?? [])
        this.parentFieldsName = data?.parentFieldsName ?? null;
        this.childFieldsName = data?.childFieldsName ?? null;
    }

    save(mappingId: number, isNew: boolean = false, sucessCallback: Function = null, failureCallback: Function = null) {
        let model = {
            isNew: isNew,
            relationship: this,
            mappingId: mappingId
        };

        let customFailureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to save relationship";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);

            if (failureCallback) {
                failureCallback();
            }
        };

        irGlobal.updateFromServer({},
            urlConfigs.relationship + "/Save",
            model,
            function (data) {
                if (data.success) {
                    if (model.isNew) {
                        model.relationship.id = data.id;
                    }

                    if (sucessCallback) {
                        sucessCallback(data);
                    }
                }
                else {
                    customFailureFunction(data.message, "", {} as any);
                }
            }.bind(this),
            customFailureFunction,
            true,
            "POST",
            true);
    }

    delete(mappingId: number, sucessCallback: Function = null) {
        irGlobal.updateFromServer({},
            urlConfigs.relationship + "/Delete",
            { id: this.id, mappingId: mappingId },
            sucessCallback,
            function (textStatus, errorThrown, errorItem: IError) {
                errorItem.userMessage = "Failed to delete relationship";
                irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
            },
            true,
            "POST",
            true);
    }
}

enum JoinTypeEnum {
    Left = 0,
    Inner = 1
}

class RelationshipTableVM {
    id: number;
    name: string;
    displayName: string;
    isPrinciple: boolean;
    visible: boolean;
    fields: Array<RelationshipTableFieldVM>;
}
class RelationshipTableFieldVM {
    id: number;
    name: string;
    displayName: string;
    visible: boolean;
    type: DataTypeEnum;
    tableId: number;
}